module.exports = __webpack_public_path__ + "img/浠水县中医院.18e3946d.png";